import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
// import _ from 'lodash';
import Scroll from 'react-scroll/modules';
import SampleVideos from './SampleVideos';
import SampleOsce from './SampleOsce';
// import {containers as BaseContainers} from '../../../modules/core';
// import landingHeroImg from 'images/landing/doc.png';
import featureImg from 'images/landing/example.png';
import optionOne from 'images/landing/optionOne.svg';
import optionTwo from 'images/landing/optionTwo.svg';
import optionThree from 'images/landing/optionThree.svg';
// import optionFour from 'images/landing/optionFour.svg';
import MailingList from 'modules/informations/MailingList';

let scroll = Scroll.animateScroll;

// const {Footer} = BaseContainers;

@withRouter
export default class extends Component {
  state = {
    courses: []
  }

  componentDidMount() {
    this.listener = this.props.history.listen(location => {
      this.initScroll(location)
    });
  }

  initScroll(location){
    if(location.pathname === '/pricing') {
      scroll.scrollTo(3075, {isDynamic: true});
    }
    else {
      scroll.scrollToTop();
    }
  }

  componentWillUnmount(){
    this.listener();
  }

  render() {
    return (
      <div className="landing">
        <div className='subscriptions-container'>
          <div className='subscriptions-wrapper'>
            <div className='subscriptions-content-item-wrapper-img'>
              <div className='subscriptions-content-item-wrapper-img-child'>
                <h2>Revise and Prepare for your</h2>
                <h1>Pharmacy PRE Exam</h1>
                {/* <span>A question bank with over 1,500 MICGP CKT style questions geared towards the ICGP CKT requirements.</span> */}
                {/* <span>Over</span> */}
                <ul style={{listStyle: 'none'}}>
                  <li>
                    {'> 20 hours of PRE exam topics covered via video format'}
                  </li>
                  <li>
                    {'> 30 OSCE scenarios'}
                  </li>
                  <li>
                    {'> 100 MCQ style questions'}
                  </li>
                  <li style={{visibility: 'hidden'}}>
                    {'Annual Subscription - € 199'}
                  </li>
                  <li>
                    {'Annual Subscription - € 199'}
                  </li>
                  <li>
                    {'3 Months Subscription - € 129'}
                  </li>
                </ul>
                {/* <span>to help you prepare for your PRE Exam</span> */}
                <Link className="btn-new-main" to='/signUp'>Create Your Account</Link>
                {/* <div className='subscriptions-items-wrapper'> */}
                  {/* <div className='subscriptions-item'>
                    <span>€ 595</span>
                    <p>Annual Subscription</p>
                  </div> */}
                  {/* <div className='subscriptions-item'>
                    <span>€ 295</span>
                    <p>6 Month Subscription</p>
                  </div>
                  <div className='subscriptions-item'>
                    <span>€ 129</span>
                    <p>3 Month Subscription</p>
                  </div> */}
                {/* </div> */}
              </div>
            </div>
            {/* <div className='subscriptions-content-item-wrapper'>
              <div className='subscriptions-img-wrapper'>
                <img src={landingHeroImg} />
              </div>
            </div> */}
          </div>
        </div>
        <div className='features-container'>
          <h2>Features</h2>
          <div className='features-wrapper'>
            <div className='subscriptions-content-item-wrapper'>
              <div className='features-items-wrapper'>
                <div className='features-item'>
                  <img src={optionOne} />
                  <p>Video content produced by a team of pharmacists who are experts on the PRE requirements</p>
                </div>
                <div className='features-item'>
                  <img src={optionTwo} />
                  <p>MCQ questions including detailed explanations covering everything you need to know</p>
                </div>
                <div className='features-item'>
                  <img src={optionThree} />
                  <p>OSCE scenarios to help you demonstrate clinical skills and competence</p>
                </div>
                {/* <div className='features-item'>
                  <img src={optionFour} />
                  <p>Performance data giving an in-depth understanding of your performance in each specialty.</p>
                </div> */}
              </div>
            </div>
            {/* <div className='subscriptions-content-item-wrapper'>
              <div className='subscriptions-img-wrapper'>
                <img src={featureImg} />
              </div>
            </div> */}
          </div>
        </div>
        <div className='sample-content-section'>
          <SampleVideos />
          <SampleOsce />
        </div>
        <MailingList />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/modules/landing/containers/Landing.js